import { inputClass } from "@/components/common/surfaceClasses";
import { matchablePct } from "@/components/audience-data/audienceDataFormat";
import type { SsdImportJob } from "@/lib/ssdSalesClient";

function JobSummary({ job }: { job: SsdImportJob }) {
  return (
    <dl className="grid grid-cols-1 gap-2 text-sm text-gray-700 sm:grid-cols-2 dark:text-zinc-300">
      <div className="min-w-0">
        <dt className="text-xs text-gray-500 dark:text-zinc-400">File</dt>
        <dd className="truncate font-medium">{job.filename || "—"}</dd>
      </div>
      <div>
        <dt className="text-xs text-gray-500 dark:text-zinc-400">Status</dt>
        <dd className="capitalize">{job.status}</dd>
      </div>
      <div>
        <dt className="text-xs text-gray-500 dark:text-zinc-400">Inserted / updated / skipped / issues</dt>
        <dd>
          {job.inserted_count} / {job.updated_count} / {job.skipped_count} / {job.issue_count}
        </dd>
      </div>
      <div>
        <dt className="text-xs text-gray-500 dark:text-zinc-400">Matchable</dt>
        <dd>
          {job.matchable_count} ({matchablePct(job.matchable_count, job.row_count)})
        </dd>
      </div>
    </dl>
  );
}

export function AudienceDataImportCard(props: {
  ingesting: boolean;
  latestJob: SsdImportJob | null;
  onFile: (file: File) => void;
}) {
  return (
    <div className="min-w-0 space-y-3">
      <label className="block min-w-0 text-sm text-gray-700 dark:text-zinc-300">
        CSV file
        <input
          type="file"
          accept=".csv,text/csv"
          className={`mt-1 block min-w-0 max-w-full ${inputClass}`}
          disabled={props.ingesting}
          onChange={(e) => {
            const file = e.target.files?.[0];
            e.target.value = "";
            if (file) props.onFile(file);
          }}
        />
      </label>
      {props.ingesting ? <p className="text-sm text-gray-500 dark:text-zinc-400">Importing…</p> : null}
      {props.latestJob ? (
        <div className="min-w-0">
          <p className="mb-2 text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-zinc-400">
            Last job
          </p>
          <JobSummary job={props.latestJob} />
          {props.latestJob.error_message ? (
            <p className="mt-2 text-sm text-red-700 dark:text-red-300">{props.latestJob.error_message}</p>
          ) : null}
        </div>
      ) : (
        <p className="text-sm text-gray-500 dark:text-zinc-400">No imports yet.</p>
      )}
    </div>
  );
}
